"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var dynamic_1 = __importDefault(require("next/dynamic"));
var react_1 = __importStar(require("react"));
var Filter_1 = __importDefault(require("./Filter"));
var GamesByFilters_1 = __importDefault(require("./GamesByFilters"));
var SearchBarDropDown_1 = require("./SearchBar/SearchBarDropDown");
var SearchByProvider_1 = __importDefault(require("./SearchBar/SearchByProvider"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var constants_1 = require("./constants");
var ProvidersSelect = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('./ProvidersSelect')); }); });
var FiltersAndSearch = function (_a) {
    var defaultSearchCollection = _a.defaultSearchCollection, categoriesToShow = _a.categoriesToShow, gameCardPlaceholder = _a.gameCardPlaceholder, _b = _a.columnsCount, columnsCount = _b === void 0 ? 6 : _b, _c = _a.correctionCoefficient, correctionCoefficient = _c === void 0 ? undefined : _c, _d = _a.hasCollections, hasCollections = _d === void 0 ? true : _d, _e = _a.hasProviders, hasProviders = _e === void 0 ? true : _e, imageLoading = _a.imageLoading, _f = _a.titlePosition, titlePosition = _f === void 0 ? 'left' : _f, _g = _a.navigationPosition, navigationPosition = _g === void 0 ? 'top' : _g;
    var _h = (0, swr_hooks_1.useCache)(), getDataFromCache = _h.getDataFromCache, setDataToCache = _h.setDataToCache;
    var collectionsRef = (0, react_1.useRef)(null);
    (0, swr_hooks_1.useScrollToCollections)(collectionsRef);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var games = (0, swr_hooks_1.useGamesByCategories)().data;
    var _j = (0, react_1.useState)(function () {
        var collection = getDataFromCache(constants_1.SELECTED_COLLECTION);
        return collection || collection === null
            ? collection
            : defaultSearchCollection;
    }), selectedCollection = _j[0], setSelectedCollection = _j[1];
    var _k = (0, react_1.useState)(getDataFromCache(constants_1.OPEN_SEARCH_BY_PROVIDER) || false), isOpenSearchByProvider = _k[0], setOpenSearchByProvider = _k[1];
    var _l = (0, react_1.useState)(getDataFromCache(constants_1.OPEN_SEARCH_BY_TITLE) || false), isOpenSearchByTitle = _l[0], setOpenSearchByTitle = _l[1];
    var goToGamesCollections = (0, react_1.useCallback)(function () {
        (0, apps_shared_1.slowScrollToElementById)('gamesCollections');
    }, []);
    var chooseCollection = (0, react_1.useCallback)(function (collection) {
        setSelectedCollection(collection);
        setDataToCache(constants_1.SELECTED_COLLECTION, collection);
    }, [setSelectedCollection, setDataToCache]);
    var inFiltersCategories = (0, react_1.useMemo)(function () {
        return categoriesToShow
            .filter(function (collection) {
            var _a, _b;
            return collection.place === 'menu' &&
                (((_b = (_a = games === null || games === void 0 ? void 0 : games[collection.slug]) === null || _a === void 0 ? void 0 : _a.previewGames) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
        })
            .map(function (item) { return item.slug; });
    }, [games, categoriesToShow]);
    var onClickCollections = (0, react_1.useCallback)(function (collection) {
        chooseCollection(collection);
        setOpenSearchByProvider(false);
        setOpenSearchByTitle(false);
        setDataToCache(constants_1.OPEN_SEARCH_BY_PROVIDER, false);
        setDataToCache(constants_1.OPEN_SEARCH_BY_TITLE, false);
    }, [setDataToCache, chooseCollection]);
    var onClickSearch = (0, react_1.useCallback)(function () {
        if (isOpenSearchByTitle)
            onClickCollections(inFiltersCategories[0]);
        else {
            setOpenSearchByTitle(!isOpenSearchByTitle);
            setOpenSearchByProvider(false);
            setDataToCache(constants_1.OPEN_SEARCH_BY_PROVIDER, false);
            setDataToCache(constants_1.OPEN_SEARCH_BY_TITLE, !isOpenSearchByTitle);
            chooseCollection(null);
        }
    }, [
        setDataToCache,
        chooseCollection,
        onClickCollections,
        isOpenSearchByTitle,
        inFiltersCategories,
    ]);
    var onClickSearchByProvider = (0, react_1.useCallback)(function () {
        if (isOpenSearchByProvider)
            onClickCollections(inFiltersCategories[0]);
        else {
            setOpenSearchByProvider(!isOpenSearchByProvider);
            setOpenSearchByTitle(false);
            setDataToCache(constants_1.OPEN_SEARCH_BY_PROVIDER, !isOpenSearchByProvider);
            setDataToCache(constants_1.OPEN_SEARCH_BY_TITLE, false);
            chooseCollection(null);
        }
    }, [
        chooseCollection,
        onClickCollections,
        inFiltersCategories,
        isOpenSearchByProvider,
        setOpenSearchByProvider,
        setDataToCache,
    ]);
    return (react_1.default.createElement("div", { ref: collectionsRef, className: styles_module_scss_1.default.wrapper },
        Object.keys(breakpoints).length > 0 && breakpoints.mobile && (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement(ProvidersSelect, { isProviderDropdownOpen: isOpenSearchByProvider, onClickHandle: onClickSearchByProvider }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filterCategoryWrapper }, inFiltersCategories.map(function (collection) { return (react_1.default.createElement(Filter_1.default, { key: collection, slug: collection, onClick: function () { return onClickCollections(collection); }, isActive: selectedCollection === collection, title: t("".concat(collection)), isSearchByProvider: isOpenSearchByProvider })); })),
            react_1.default.createElement("div", null,
                hasCollections &&
                    Object.keys(breakpoints).length > 0 &&
                    !breakpoints.mobile &&
                    !breakpoints.tablet && (react_1.default.createElement(Filter_1.default, { title: t('collections'), slug: "gamesCollections", onClick: goToGamesCollections })),
                hasProviders &&
                    Object.keys(breakpoints).length > 0 &&
                    !breakpoints.mobile && (react_1.default.createElement(Filter_1.default, { title: t('providers'), slug: "searchByProvider", onClick: onClickSearchByProvider, isActive: isOpenSearchByProvider })),
                Object.keys(breakpoints).length > 0 &&
                    !breakpoints.mobile &&
                    !breakpoints.tablet && (react_1.default.createElement(Filter_1.default, { title: t('search'), onClick: onClickSearch, slug: "search", isActive: isOpenSearchByTitle })))),
        !isOpenSearchByTitle && !isOpenSearchByProvider && (react_1.default.createElement(GamesByFilters_1.default, { selectedCollection: selectedCollection, gameCardPlaceholder: gameCardPlaceholder, columnsCount: columnsCount, correctionCoefficient: correctionCoefficient, imageLoading: imageLoading, titlePosition: titlePosition, navigationPosition: navigationPosition })),
        isOpenSearchByProvider && (react_1.default.createElement(SearchByProvider_1.default, { gameCardPlaceholder: gameCardPlaceholder, correctionCoefficient: correctionCoefficient })),
        isOpenSearchByTitle && (react_1.default.createElement(SearchBarDropDown_1.SearchByValue, { gameCardPlaceholder: gameCardPlaceholder }))));
};
exports.default = react_1.default.memo(FiltersAndSearch);
